import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PROJECT } from '../../../constants/constants';
import { IProject } from '../../../interface/interfaces';

interface IInitialState {
    project: IProject | null;
}

const storedProject = localStorage.getItem(PROJECT);

let initialProject: IProject | null = null;
try {
    initialProject = storedProject ? JSON.parse(storedProject) : null;
} catch (error) {
    console.error('Error parsing project from localStorage:', error);
    initialProject = null;
}

const initialState: IInitialState = {
    project: initialProject,
};

const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        saveProject: (state: IInitialState, action: PayloadAction<IProject>) => {
            state.project = action.payload;
            localStorage.setItem(PROJECT, JSON.stringify(action.payload));
        },

        removeProject: (state: IInitialState) => {
            state.project = null;
            localStorage.removeItem(PROJECT);
        },
    },
});

export default projectSlice.reducer;
export const { saveProject, removeProject } = projectSlice.actions;
